export default function unscheduleMenuItem(unscheduleCallbacks) {
  return {
    cls: "pendo-unschedule-menu-item",
    menu: unschduleSubMenuItems(unscheduleCallbacks),
    name: "unschdeule",
    text: "Unschedule",
  };
}

function unschduleSubMenuItems({ unscheduleBlock, unscheduleWorkOrder }) {
  return [
    {
      cls: "pendo-unschedule-work-block-context-menu-item",
      icon: false,
      name: "unschedule-work-block",
      onItem: unscheduleBlock,
      text: "Work block",
    },
    {
      cls: "pendo-unschedule-work-order-context-menu-item",
      name: "unschedule-work-order",
      onItem: unscheduleWorkOrder,
      text: "Work order",
    },
  ];
}
